import { ThrowLiteError } from '../../../lite-error.js';

const BASE_DIRECTION = /var\s+([A-Za-z_]\w*)\s*=\s*normalize\(\w+\.positionUVW\)\s*;/;
const _apply = (fragment) => {
  const direction = fragment.match(BASE_DIRECTION)?.[1];
  if (!direction) {
    ThrowLiteError(268);
  }
  const rotatedDirection = `let _erc=cos(scene.envRotationY);let _ers=sin(scene.envRotationY);${direction}=vec3f(${direction}.x*_erc+${direction}.z*_ers,${direction}.y,-${direction}.x*_ers+${direction}.z*_erc);`;
  return fragment.replace(BASE_DIRECTION, `$&${rotatedDirection}`);
};

export { _apply };
//# sourceMappingURL=environment-rotation-fragment.js.map
